<fui-rows [formGroup]="editService.formGroup">
    <fui-row>
        <fui-two-columns>
            <fui-column>
                <fui-append-field>
                    <wbo-text-edit-control formControlName="name" [(ngModel)]="model.data.name"></wbo-text-edit-control>
                    <wbo-entity-discontinued-edit-control
                        formControlName="discontinued"
                        [(ngModel)]="model.data.discontinued"></wbo-entity-discontinued-edit-control>
                </fui-append-field>

            </fui-column>
            <fui-column formGroupName="inventoryGroup">
                <wbo-inventory-group-single-select-edit-control formControlName="invGroupId"
                                                                [(ngModel)]="model.data.inventoryGroup.invGroupId"></wbo-inventory-group-single-select-edit-control>
            </fui-column>
        </fui-two-columns>
    </fui-row>
    <fui-row>
        <fui-two-columns>
            <fui-column>
                <wbo-tax-multi-select-edit-control formControlName="taxes" [(ngModel)]="model.data.taxes"
                                                   [multiObjectValueType]="true"></wbo-tax-multi-select-edit-control>
            </fui-column>
            <fui-column formGroupName="manufacturer">
                <wbo-manufacturer-single-select-edit-contorl formControlName="manufacturerId"
                                                             [(ngModel)]="model.data.manufacturer.manufacturerId"></wbo-manufacturer-single-select-edit-contorl>
            </fui-column>
        </fui-two-columns>
    </fui-row>
    <fui-row [label]="'wbo.inventory.edit.purchaseOrdering'">
        <fui-two-columns formGroupName="standardStockSize">
            <fui-column>
                <wbo-numeric-edit-control formControlName="measureAmt"
                                          [(ngModel)]="model.data.standardStockSize.measureAmt"></wbo-numeric-edit-control>
            </fui-column>
            <fui-column formGroupName="measure">
                <wbo-measure-single-select-edit-control *ngIf="model.data.inventoryId == null"
                                                        formControlName="measureId"
                                                        [(ngModel)]="model.data.standardStockSize.measure.measureId"></wbo-measure-single-select-edit-control>
                <wbo-measure-single-select-edit-control *ngIf="model.data.inventoryId != null"
                                                        formControlName="measureId"
                                                        [(ngModel)]="model.data.standardStockSize.measure.measureId"
                                                        [inventoryMeasureIdentifier]="model.data.standardStockSize.measure.measureId"
                                                        ></wbo-measure-single-select-edit-control>
            </fui-column>
        </fui-two-columns>
    </fui-row>
    <fui-row>
        <fui-column>
            <wbo-edit-grid [data]="model.data.suppliedInventories" [editable]="true" [removable]="true"
                           [entityPath]="'suppliedInventories'" (saved)="preferredSupplierSaved($event)">
                <wbo-edit-link-column field="vendor.name" componentPath="vendor"
                                      [editComponent]="SupplierEditPageComponent"
                                      [editMode]="EditMode.VIEW"></wbo-edit-link-column>
                <wbo-numeric-column field="stockSize.measureAmt" [editable]="true"></wbo-numeric-column>
                <wbo-measure-single-select-column field="stockSize.measure"
                                                  [extendedEditComponentParams]="restrictedBaseMeasureIdParams"
                                                  [extendedSearchComponentParams]="restrictedBaseMeasureIdParams"
                                                  [inventoryMeasureIdentifier]="model.data.standardStockSize.measure.measureId"
                                                  [convertToRequired]="true"
                                                  [editable]="true"></wbo-measure-single-select-column>
                <wbo-text-column field="code" [editable]="true"></wbo-text-column>
                <wbo-numeric-column field="negotiatedSupplierPrice" [editable]="true"></wbo-numeric-column>
                <wbo-checkbox-column field="preferredSupplier" [editable]="true"></wbo-checkbox-column>
                <wbo-edit-grid-add-row [identifierField]="'vendorId'" componentPath="vendor"
                                       [validateRecordExists]="false" #addRow [customAddQuickSelect]="true">
                    <wbo-edit-grid-add-row-quick-add (onSelect)="addRow.addRow($event, true, false)">
                        <wbo-supplier-single-select-edit-control></wbo-supplier-single-select-edit-control>
                    </wbo-edit-grid-add-row-quick-add>
                    <wbo-edit-grid-add-row-actions>
                        <wbo-edit-grid-add-row-search
                            [searchComponent]="SupplierSearchPageComponent"></wbo-edit-grid-add-row-search>
                        <wbo-edit-grid-add-row-new-entity
                            [editComponent]="SupplierEditPageComponent"></wbo-edit-grid-add-row-new-entity>
                    </wbo-edit-grid-add-row-actions>
                </wbo-edit-grid-add-row>
            </wbo-edit-grid>
        </fui-column>
    </fui-row>
</fui-rows>

